import Client from './HttpClient';

const baseUrl = '/eagle-api/manage-deposit';

// Get deposit settings/rules for a merchant
const getSettings = (merchantId) => {
  return Client.get(
    `/wombat-api/manage-card/${merchantId}/recharge-strategies`,
    { merchantId, status: 0 }
  );
};

// Place a deposit order
const place = (merchantId, payload) => {
  return Client.post(`${baseUrl}/${merchantId}/createDepositOrder`, payload);
};

// Get deposit order detail
const orderDetail = (merchantId, orderId) => {
  return Client.get(`${baseUrl}/${merchantId}/orderDetail/${orderId}`);
};

// // Get deposit history
// const history = (customerId, merchantId, page, pageSize) => {
//   return Client.get(`${baseUrl}/${merchantId}/history/${customerId}`, {
//     page,
//     pageSize,
//   });
// };

export default {
  getSettings,
  place,
  orderDetail,
  // history,
};
